/**
 * @desc 红人领用管理-分页查询
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.ResponseDto<defs.kol.IPage<defs.kol.UseCelebrityResponseDto>>;
export function request(
  params: API.kol.useCelebrity.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/useCelebrity/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
